export const CUSTOM_SORT_FIELDS: Record<string, string> = {
  vehicle: 'Vehicle',
  driver: 'Driver',
  assignedUser: 'AssignedUser',
  zoneId: 'Zone',
};
